import { useEffect, useState } from "react";

import "../css/Dashboard.css";

import { getDashboard } from "../services/dashboardService";

import DashboardCards from "../components/dashboard/DashboardCards";

import PendingProviders from "../components/dashboard/widgets/PendingProviders";
import RecentOrders from "../components/dashboard/widgets/RecentOrders";

function Dashboard() {

    const [dashboard, setDashboard] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadDashboard();
    }, []);

    const loadDashboard = async () => {

        try {

            const res = await getDashboard();

            if (res.success) {
                setDashboard(res.dashboard);
            }

        } catch (error) {

            console.error("Dashboard Error:", error);

        } finally {

            setLoading(false);

        }
    };

    if (loading) {
        return (
            <div className="admin-dashboard">
                <h2>Loading Dashboard...</h2>
            </div>
        );
    }

    return (

        <div className="admin-dashboard">

            {/* Header */}

            <div className="dashboard-page-header">

                <h1>Dashboard</h1>

                <p>
                    Welcome back, Administrator 👋
                </p>

            </div>

            {/* Summary Cards */}

            <DashboardCards dashboard={dashboard} />

            {/* Bottom Section */}

            <div className="dashboard-grid">

                <RecentOrders dashboard={dashboard} />

                <PendingProviders dashboard={dashboard} />

            </div>

        </div>

    );

}

export default Dashboard;